import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import { LoadingService } from 'src/app/_services/local/loading.service';
import { AccontService } from 'src/app/_services/madu-api/accont.service';
import { GenericValidator } from 'src/app/_classes/generic.form.validator';
import { UserCad } from 'src/app/_models/user.cad';
import { User } from 'src/app/_models/user';
import { UserEdicao } from 'src/app/_models/user.edicao';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserPass } from 'src/app/_models/user.pass';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit, AfterViewInit {
  @ViewChild('modificarPasswordModal') public modificarPasswordModal: ModalDirective;
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[]

  public usuarioForm: FormGroup;
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  public displayMessage: { [key: string]: string } = {};
  private usuarioCad: UserCad;
  public usuarios: UserEdicao[] = [];
  public usuarioEmEdicao: UserEdicao;
  public errors: any = [];
  public errorsPassword: any[] = [];
  public inEdition: boolean = false;
  public passwordForm: FormGroup;
  public usuarioPassword: UserPass;

  constructor(private fb: FormBuilder,
    private accontService: AccontService,
    private toasterService: ToasterService,
    private loadingService: LoadingService) {

    this.validationMessages = {
      nome: {
        required: 'O Nome é obrigatório.'
      },
      email: {
        required: 'O E-Mail é obrigatório.'
      },
      password: {
        required: 'A senha é obrigatória.'
      },
      confirmPassword: {
        required: 'A confirmação da senha é obrigatória.'
      }
    };

    this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit(): void {
    this.usuarioForm = this.fb.group({
      id: [''],
      nome: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      vincNfeCaminhao: [false],
      etiquetasMarcopolo: [false],
      log: [false],
      usuarios: [false]
    });

    this.passwordForm = this.fb.group({
      email: [''],
      password: [''],
      confirmPassword: ['']
    });
  }

  ngAfterViewInit(): void {
    this.obterUsuarios();
  }

  private onError(error) {
    this.loadingService.clearShowLoading();
    console.log(error);
    if (error.errors != null) {
      this.errors = error.errors;
      this.toasterService.pop('error', 'Opa :(', 'Algo deu errado!');
    }
  }

  private onErrorModal(error) {
    this.loadingService.clearShowLoading();
    console.log(error);
    if (error.errors != null) {
      this.errorsPassword = error.errors.Password;
      this.toasterService.pop('info', 'Opa :(', 'Algo deu errado!');
    }
  }

  limparForm() {
    this.inEdition = false;
    this.usuarioForm.reset({
      id: '',
      nome: '',
      email: '',
      password: '',
      confirmPassword: '',
      etiquetasMarcopolo: false,
      log: false,
      usuarios: false
    })
  }

  limparFormPassword() {
    this.passwordForm.reset({
      email: '',
      password: '',
      confirmPassword: ''
    })
    this.errorsPassword = [];
  }

  salvar() {

    if (!this.inEdition)
      this.novoUsuario();
    else
      this.editarUsuario();
  }

  novoUsuario() {
    this.displayMessage = this.genericValidator.processMessages(this.usuarioForm);
    if (this.usuarioForm.dirty && this.usuarioForm.valid) {
      let p = Object.assign({}, this.usuarioCad, this.usuarioForm.value)

      if (p.password != p.confirmPassword) {
        this.toasterService.pop('warning', 'Opa :|', 'As senhas não são iguais...');
        return;
      }

      this.loadingService.showLoading(true);
      this.accontService.registrarLoginAdmin(p)
        .subscribe(
          result => {
            this.toasterService.pop('success', 'Ok :)', 'Usuário cadastrado!');
            this.limparForm();
            this.obterUsuarios();
          },
          error => { this.onError(error) });
    }
  }

  editarUsuario() {
    let p = Object.assign({}, this.usuarioEmEdicao, this.usuarioForm.value)

    if (p.nome == '' || p.email == '') {
      this.toasterService.pop('warning', 'Opa :|', 'Nome e e-mail são obrigatórios...');
      return;
    }

    this.loadingService.showLoading(true);
    this.accontService.editarUsuario(p)
      .subscribe(
        result => {
          this.toasterService.pop('success', 'Ok :)', 'Usuário editado!');
          this.limparForm();
          this.obterUsuarios();
        },
        error => { this.onError(error) });
  }

  colocarUsuarioEmEdicao(usuarioSel: UserEdicao) {
    this.inEdition = true;
    this.usuarioEmEdicao = usuarioSel;
    this.carregarForm();
  }

  carregarForm() {
    this.usuarioForm.get('id').setValue(this.usuarioEmEdicao.id);
    this.usuarioForm.get('email').setValue(this.usuarioEmEdicao.email);
    this.usuarioForm.get('nome').setValue(this.usuarioEmEdicao.nome);

    this.usuarioForm.get('etiquetasMarcopolo').setValue(this.usuarioEmEdicao.etiquetasMarcopolo);
    this.usuarioForm.get('log').setValue(this.usuarioEmEdicao.log);
    this.usuarioForm.get('usuarios').setValue(this.usuarioEmEdicao.usuarios);
  }

  redefinirSenha(usuarioSel: UserEdicao) {
    this.limparFormPassword();
    this.passwordForm.get('email').setValue(usuarioSel.email);
    this.passwordForm.get('password').setValue("");
    this.passwordForm.get('confirmPassword').setValue("");
    this.modificarPasswordModal.show();
  }

  trocarPassword() {
    let p = Object.assign({}, this.usuarioPassword, this.passwordForm.value)

    if (p.password == "" || p.confirmPassword == "") {
      this.toasterService.pop('warning', 'Opa :|', 'Senhas não podem estar em branco...');
      return;
    }

    if (p.password != p.confirmPassword) {
      this.toasterService.pop('warning', 'Opa :|', 'As senhas não são iguais...');
      return;
    }

    this.loadingService.showLoading(true);
    this.accontService.redefinirSenhaInternamente(p)
      .subscribe(
        result => {
          this.loadingService.clearShowLoading();
          this.limparFormPassword();
          this.modificarPasswordModal.hide();
          this.toasterService.pop('success', 'Ok :)', 'Senha editada!');
        },
        error => { this.onErrorModal(error) });
  }

  bloquearUsuario(usuarioSel: UserEdicao) {
    this.loadingService.showLoading(true);
    this.accontService.bloquearUsuario(usuarioSel.email)
      .subscribe(
        result => {
          this.toasterService.pop('success', 'Ok :)', 'Usuário Bloqueado!');
          usuarioSel.block = true;
          this.loadingService.clearShowLoading();
        },
        error => { this.onError(error) });
  }

  desBloquearUsuario(usuarioSel: UserEdicao) {
    this.loadingService.showLoading(true);
    this.accontService.desBloquearUsuario(usuarioSel.email)
      .subscribe(
        result => {
          this.toasterService.pop('success', 'Ok :)', 'Usuário Desbloqueado!');
          usuarioSel.block = false;
          this.loadingService.clearShowLoading();
        },
        error => { this.onError(error) });
  }

  excluirUsuario(usuarioId: string) {

    var confirmDelete = prompt("Por favor confirme essa ação\
    \nDigite SIM para excluir este registro.", "");

    if (!confirmDelete || confirmDelete.toLowerCase() != 'sim') {
      this.toasterService.pop('error', 'Ops :(', 'Exclusão cancelada, confirmação invalida!');
    }
    else {
      this.loadingService.showLoading(true);
      this.accontService.excluirUsuario(usuarioId)
        .subscribe(
          result => {
            this.toasterService.pop('success', 'Ok :)', 'Usuário removido com sucesso!');
            this.obterUsuarios();
            this.loadingService.clearShowLoading();
          },
          error => { this.onError(error) });
    }
  }

  obterUsuarios() {
    this.loadingService.showLoading(true);
    this.accontService.getAllUsersEdicao()
      .subscribe(
        result => { this.onSearchCompleteObterUsuarios(result) },
        error => { this.onError(error) });
  }

  onSearchCompleteObterUsuarios(result): void {
    this.errors = [];
    this.usuarios = result;
    this.loadingService.clearShowLoading();
  }
}